<template>
  <div>
    <my-menu menu-name="about"></my-menu>
    <div class="banner">
      <img class="bg" src="../assets/images/about/aheader.png" />
      <div class="about_header_content">
        <div class="about_desc">
          <div class="about_logo">
            <img src="../assets/images/about/logo.png" />
          </div>
          <div class="about_text">
            <div class="v_line"></div>
            <p class="p_title">维学教育科技</p>
            <p>北京维学教育科技有限公司是一家专注K12英语教育的移动互联网创业公司，
            公司利用多年的英语教育经验，提供全方位的学习解决方案，并将成熟的智能教育技术与产品，
            运用到学校更多的教与学场景，致力打造专注，知名的网络教育品牌。</p>
          </div>
        </div>
      </div>
    </div>


    <div class="about_content">
      <div class="about">
          <p>Enjoy Studying</p>
          <div class="v_line" style="background-color: #7c7c7c"></div>
          <p>加入我们</p>
      </div>

      <div class="join">
        <ul class="join_menu">
          <li v-bind:class="{active: all}">
            <a href="javascript:;" @click="clickHandler($event,'all')">全部</a>
          </li>
          <li v-bind:class="{active: product}">
            <a href="javascript:;" @click="clickHandler($event,'product')">产品</a>
          </li>
          <li v-bind:class="{active: technology}">
            <a href="javascript:;" @click="clickHandler($event,'technology')">技术</a>
          </li>
          <li v-bind:class="{active: design}">
            <a href="javascript:;" @click="clickHandler($event,'design')">设计</a>
          </li>
          <li v-bind:class="{active: operation}">
            <a href="javascript:;" @click="clickHandler($event,'operation')">运营</a>
          </li>
        </ul>
        <div class="job_list">
          <div class="job_item" v-for="(item,index) in positions" v-bind:key="index">
            <div class="job_position">
              <div class="job_title">{{item.name}}</div>
              <div class="job_require">
                <div class="job_require_title">职位要求</div>
                <div class="job_require_content">
                  <div v-html="item.require"></div>
                </div>
              </div>
            </div>
            <div class="job_content">
              <div class="job_content_title">工作内容</div>
              <div class="job_content_text">
                <div v-html="item.content"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>

    <my-footer></my-footer>
  </div>
</template>

<script>
  import MyFooter from '@/components/Footer'
  import MyMenu from '@/components/Menu'
  import Positions from '@/assets/data/position'

  export default {
    data () {
      return {
        positions: [],
        all: true,
        product: false,
        technology: false,
        design: false,
        operation: false
      }
    },
    created () {
      this.positions = Positions.positions
    },
    components: {
      MyFooter,
      MyMenu
    },
    methods: {
      clickHandler (e, cate = 'all') {
        if (cate === 'all') {
          this.positions = Positions.positions
          this.all = true
        } else {
          this.positions = Positions.positions.filter(function (value) {
            return value.category === cate
          })
        }

        this.reset(cate)
      },
      reset (cate) {
        this.all = false
        this.product = false
        this.technology = false
        this.design = false
        this.operation = false
        switch (cate) {
          case 'all':
            this.all = true
            break
          case 'product':
            this.product = true
            break
          case 'technology':
            this.technology = true
            break
          case 'design':
            this.design = true
            break
          case 'operation':
            this.operation = true
            break
          default:
            this.all = true
            break
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// About.vue?eb21e3f4